/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { deleteAccountPostRequestSchema } from './deleteAccountPostRequestSchema.ts';
import { deleteAccountPostResponseSchema } from './deleteAccountPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postDeleteAccount200Schema = z.lazy(() => deleteAccountPostResponseSchema);

/**
 * @description 505 response
 */
export const postDeleteAccount505Schema = z.any();

export const postDeleteAccountMutationRequestSchema = z.lazy(() => deleteAccountPostRequestSchema);

export const postDeleteAccountMutationResponseSchema = z.lazy(() => postDeleteAccount200Schema);
